import { Button } from "@/components/ui/button";
import { InputFormik } from "@/components/ui/input-formik";
import { Label } from "@/components/ui/label";
import { useToast } from "@/components/ui/use-toast";
import { RequestAlterarSenha } from "@/dtos/Request/RequestAlterarSenha";
import AcessoService from "@/services/AcessoService";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import * as Yup from 'yup';

export default function AlterarSenhaPage() {
    const navigate = useNavigate();
    const { toast } = useToast()

    const formikAlterarSenha = useFormik<RequestAlterarSenha>({
        initialValues: {
            OldPassword: '',
            NewPassword: '',
            ConfirmPassword: ''
        },
        validationSchema: Yup.object({
            OldPassword: Yup.string()
                .min(5, 'Deve possuir ao menos 5 caracteres')
                .required('Obrigatório'),
            NewPassword: Yup.string()
                .min(5, 'Deve possuir ao menos 5 caracteres')
                .required('Obrigatório'),
            ConfirmPassword: Yup.string()
                .min(5, 'Deve possuir ao menos 5 caracteres')
                .required('Obrigatório')
                .test('Validar Confirmar Senha', 'Digite as duas senhas iguais', passwordToValidate => {
                    if (passwordToValidate !== formikAlterarSenha.values.NewPassword) {
                        return false;
                    }

                    return true;
                })
        }),
        onSubmit: async (values) => {
            try {
                await AcessoService.alterarSenha(values);
                toast({
                    variant: 'success',
                    description: 'Senha alterada com sucesso!',
                    duration: 3000
                })

                navigate('/perfil')
            } catch (error: any) {
                toast({
                    variant: 'destructive',
                    description: error,
                    duration: 4000
                });
            }
        }
    });


    return (
        <form onSubmit={formikAlterarSenha.handleSubmit} className="flex flex-col gap-4 mx-2 my-5">
            <h1 className="text-primary-foreground text-2xl uppercase font-black">Alteração de Senha</h1>
            <div className="flex flex-col">
                <div className="w-full md:w-6/12">
                    <div className="flex flex-col gap-2 mt-3">
                        <Label htmlFor="senhaAntiga">Senha antiga</Label>
                        <InputFormik
                            placeholder="Senha Antiga"
                            type="password"
                            id="OldPassword"
                            required
                            formik={formikAlterarSenha}
                            name='OldPassword'
                        />
                    </div>
                    <div className="flex flex-col gap-2 mt-3">
                        <Label htmlFor="novaSenha">Nova Senha</Label>
                        <InputFormik
                            placeholder="Digite uma Nova Senha"
                            type="password"
                            id="NewPassword"
                            required
                            formik={formikAlterarSenha}
                            name='NewPassword'
                        />
                    </div>
                    <div className="flex flex-col gap-2 mt-3">
                        <Label htmlFor="confirmPassword">Confirmar Senha</Label>
                        <InputFormik
                            placeholder="Digite sua nova senha novamente"
                            type="password"
                            id="ConfirmPassword"
                            required
                            formik={formikAlterarSenha}
                            name='ConfirmPassword'
                        />
                    </div>
                </div>
            </div>
            <div className="flex justify-end gap-3">
                <Button type="submit" disabled={formikAlterarSenha.isSubmitting || !formikAlterarSenha.isValid} className="w-40">
                    {
                        formikAlterarSenha.isSubmitting ? 'Alterando...' : 'Alterar'
                    }
                </Button>
            </div>
        </form>
    )
}